export type ThemeMode = 'light' | 'dark' | 'system';

const THEME_KEY = 'trf_theme';
const VALID_THEMES: ThemeMode[] = ['light', 'dark', 'system'];
const THEME_CHANGED_EVENT = 'trf:themeChanged';

export function getTheme(): ThemeMode {
  let stored: string | null = null;
  try { stored = localStorage.getItem(THEME_KEY); } catch { /* Safari private mode */ }
  return VALID_THEMES.includes(stored as ThemeMode) ? (stored as ThemeMode) : 'light';
}

/** Toggle the .dark root class without writing to localStorage. Used for live-preview (e.g. SettingsDialog). */
export function applyThemeClass(theme: ThemeMode): void {
  const dark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
}

export function applyTheme(theme: ThemeMode): void {
  applyThemeClass(theme);
  try { localStorage.setItem(THEME_KEY, theme); } catch { /* Safari private mode */ }
  window.dispatchEvent(new CustomEvent<ThemeMode>(THEME_CHANGED_EVENT, { detail: theme }));
}

export function onThemeChange(handler: (theme: ThemeMode) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent<ThemeMode>).detail);
  window.addEventListener(THEME_CHANGED_EVENT, listener);
  return () => window.removeEventListener(THEME_CHANGED_EVENT, listener);
}
